import React, {useState} from 'react';
import {Box, Button, Collapse, IconButton, Paper, Typography} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import {makeStyles} from '@material-ui/core/styles';
import {DetailedCandidate, LlmCandidateState} from '../../../../store/models/DuplicateCheck';
import {isExactPlacesMatch} from '../../../../util/DuplicateCheckUtil';
import {StatusBadge} from './shared';
import FieldDetailTable from './FieldDetailTable';
import LlmAssessmentBox from './LlmAssessmentBox';

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
    },
    spacer: {
        flex: 1,
    },
    matchNote: {
        marginTop: theme.spacing(1),
    },
}));

interface CandidateCardProps {
    candidate: DetailedCandidate;
    defaultExpanded: boolean;
    llmResult?: LlmCandidateState;
    onLlmCheck?: () => void;
    llmDisabled?: boolean;
}

export default function CandidateCard({candidate, defaultExpanded, llmResult, onLlmCheck, llmDisabled}: CandidateCardProps) {
    const classes = useStyles();
    const [expanded, setExpanded] = useState(defaultExpanded);

    const exactPlacesMatch = isExactPlacesMatch(candidate);

    return (
        <Paper className={classes.paper} variant="outlined">
            <div className={classes.header}>
                <StatusBadge status={candidate.status}/>
                <Typography variant="subtitle1"><b>{candidate.contact.companyLine1}</b></Typography>
                {candidate.contact.sapCustomerID && (
                    <Typography variant="body2" color="textSecondary">
                        SAP-Nr. {candidate.contact.sapCustomerID}
                    </Typography>
                )}
                <Box className={classes.spacer}/>
                <Typography variant="body2">
                    Score: <b>{Math.round(candidate.totalScore * 100)} %</b>
                </Typography>
                {onLlmCheck && (
                    <Button size="small" onClick={onLlmCheck} disabled={llmDisabled}>
                        LLM prüfen
                    </Button>
                )}
                {!exactPlacesMatch && (
                    <IconButton size="small" onClick={() => setExpanded((e) => !e)}>
                        {expanded ? <ExpandLessIcon fontSize="small"/> : <ExpandMoreIcon fontSize="small"/>}
                    </IconButton>
                )}
            </div>
            {llmResult && <LlmAssessmentBox result={llmResult}/>}
            {exactPlacesMatch ? (
                <Typography variant="body2" color="textSecondary" className={classes.matchNote}>
                    Exakter Google-Places-Match — nicht über die Gewichte beeinflussbar.
                </Typography>
            ) : (
                <Collapse in={expanded} timeout="auto">
                    <Box mt={1}>
                        <FieldDetailTable fields={candidate.fields}/>
                    </Box>
                </Collapse>
            )}
        </Paper>
    );
}
